module.exports = __webpack_public_path__ + "static/media/KR.4de3260b.png";